import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=7ed34e66&"
import script from "./TheFooter.js?vue&type=script&lang=js&"
export * from "./TheFooter.js?vue&type=script&lang=js&"
import style0 from "./TheFooter.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports